import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/actions/action.user";
import { postLogout } from "./helpers/api.helper";
import { MdOutlineLogin } from "react-icons/md";

// import { PublicClientApplication } from "@azure/msal-browser";
// import { MsalProvider } from "@azure/msal-react";
// import { msalConfig } from "./pages/auth/helpers/api.helper";
import { useMsal } from "@azure/msal-react";

/**
 *  Componente de des-logeo
 * @component
 * @returns {component} componente de des-logeo
 */

const LogOut = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();
  const cancelRef = React.useRef();
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const { instance } = useMsal();

  const logOutUrl = process.env.REACT_APP_AZURE_AD_LOGIN_CALLBACK || "";

  const singOutHandler = (instance) => {
    dispatch(logout());
    const logoutRequest = {
      account: instance.getAccountByHomeId("homeAccountId"),
      postLogoutRedirectUri: logOutUrl,
    };
    sessionStorage.clear();
    instance.logoutRedirect(logoutRequest);
  };

  /**
   * @handleButton
   * @async
   * @function
   * @param {string} res-state solicita los datos, vacia el objeto
   * @returns {object} devuelve el objeto vacio
   */

  const handleLogout = async () => {
    setLoading(true);
    const res = await postLogout();
    if (res.success) {
      singOutHandler(instance);
    } else {
      toast({
        title: "Error",
        description: "Hubo un error al cerrar sesión",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    setLoading(false);
  };

  return (
    <>
      <Button
        textColor="white"
        onClick={onOpen}
        size={"sm"}
        variant="link"
        leftIcon={<MdOutlineLogin fontSize={"20px"} />}
        placeContent={"start"}
        py={1}
      >
        Cerrar Sesión
      </Button>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Cerrar sesión
            </AlertDialogHeader>

            <AlertDialogBody>¿Seguro que desea cerrar sesión?</AlertDialogBody>

            <AlertDialogFooter>
              <Button variant="link" ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button
                disabled={loading}
                colorScheme="red"
                onClick={handleLogout}
                ml={3}
              >
                Cerrar sesión
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default LogOut;
